/**
 * The server's clock as seen from this browser, for the results pages (PR2: the shown page is computed from the
 * server-held `page_since`, so a projector whose clock is minutes off would show another page than the host
 * view). Estimated from each live read's `Date` response header (whole seconds, so +0.5 s centres it); a new
 * estimate replaces the old only when it differs by more than a second, so the pages do not jitter. Without a
 * readable header (a cross-origin dev API that does not expose it) the local clock stands in.
 */
let offsetMs = 0;

const SECOND = 1_000;

/** Note a response's `Date` header, read at `receivedAtMs` (local clock). */
export const noteServerDate = (dateHeader: string | null, receivedAtMs = Date.now()): void => {
  if (!dateHeader) return;
  const serverMs = Date.parse(dateHeader);
  if (!Number.isFinite(serverMs)) return;
  const estimate = serverMs + SECOND / 2 - receivedAtMs;
  if (Math.abs(estimate - offsetMs) > SECOND) offsetMs = estimate;
};

/** Now, on the server's clock (best estimate). */
export const serverNow = (): number => Date.now() + offsetMs;

/** Tests only. */
export const resetServerClock = (): void => {
  offsetMs = 0;
};
